import { render } from "./PhoneNumberFromStackholders.vue?vue&type=template&id=7e3631af&scoped=true"
import script from "./PhoneNumberFromStackholders.vue?vue&type=script&lang=js"
export * from "./PhoneNumberFromStackholders.vue?vue&type=script&lang=js"

import "./PhoneNumberFromStackholders.vue?vue&type=style&index=0&id=7e3631af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3631af"]])

export default __exports__